<button class="boton-imprimir">
  <img
    class="boton-imprimir__icon"
    src="../../../../../assets/imprimir-01.svg"
  />
  Imprimir
</button>
